import { DashboardContainer } from './../../dashboard.container';
import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-user-bookings',
    templateUrl: 'bookings.component.html',
    styleUrls: ['../../dashboard.component.css', './bookings.component.scss', './bookings.component.css']
})

export class BookingsComponent implements OnInit, OnDestroy {

    fees = new Array(this.dashboardContainer.activeBookings.length);

    constructor(private dashboardContainer: DashboardContainer) { }

    ngOnInit() {
        this.dashboardContainer.changeHeader();
        this.dashboardContainer.getAllBookings();
    }

    goBack() {
        window.history.back();
    }

    getActiveBookings = () => this.dashboardContainer.activeBookings;
    getPastBookings = () => this.dashboardContainer.pastBookings;
    getCancelledBookings = () => this.dashboardContainer.cancelledBookings;

    saveCreditCardInfo(data) {
        this.dashboardContainer.saveCreditCardDetails(data[0], data[1]);
    }

    cancelBooking(bookingInfo) {
        this.dashboardContainer.getBookingFees(bookingInfo[0].id)
            .subscribe(fee => {
                this.dashboardContainer.cancelBooking(bookingInfo[0].id, fee.cancellationFees, bookingInfo[1]);
            });

    }

    getFees(data) {
        // this.fees[data[2]] = '';
        if (data[1]) {
            this.dashboardContainer.getBookingFees(data[0].id)
                .subscribe(fee => {
                    this.fees[data[2]] = fee;
                });
        }
    }

    removeBooking(id) {
        this.dashboardContainer.removeBooking(id);
    }

    ngOnDestroy() { }
}
